import { FC } from 'react';
import { EPointType, TPointSummary } from '../../mapTypes';
import VesselLastPointPopupContent from './point-types/VesselLastPointPopupContent';
import VesselDailyPointPopupContent from './point-types/VesselDailyPointPopupContent';
import PortCallPopupContent from './point-types/PortCallPopupContent';
import StoppageEventPopupContent from './point-types/StoppageEventPopupContent';
import PolygonPopupContent from './point-types/PolygonPopupContent';

export interface ISignalHoverPopupContentProps {
	info: TPointSummary;
}

const SignalHoverPopupContent: FC<ISignalHoverPopupContentProps> = (props: ISignalHoverPopupContentProps) => {
	const options: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };

	return (
		<div className="flex flex-col gap-2">
			{props.info?.pointType === EPointType.VESSEL_LAST_POINT && (
				<VesselLastPointPopupContent info={props.info} />
			)}
			{props.info?.pointType === EPointType.VESSEL_DAILY_POINT && (
				<VesselDailyPointPopupContent info={props.info} />
			)}
			{props.info?.pointType === EPointType.PORT_CALL && (
				<PortCallPopupContent info={props.info} options={options} />
			)}
			{props.info?.pointType === EPointType.STOPPAGE_EVENT && (
				<StoppageEventPopupContent info={props.info} options={options} />
			)}
			{props.info?.pointType === EPointType.POLYGON && (
				<PolygonPopupContent info={props.info} />
			)}
		</div>
	);
};

export default SignalHoverPopupContent;
